// extracted by mini-css-extract-plugin
export default {"spinner":"LoadingSpinner_spinner__eoa90","spinner1":"LoadingSpinner_spinner1__XAsrf","spinner2":"LoadingSpinner_spinner2__Ickb6","spinner3":"LoadingSpinner_spinner3__2EamN"};